import { createTypes } from 'redux-create-types';
import { ajaxJson } from 'imports/ajax';
import { teacherActionCreators } from 'db/teacher/teacher.action.js';
import { map2TeacherObj } from 'imports/mapper';

const namespace = 'page-teacherList';

export const teacherListActions = createTypes([
    'setTeacherList',
    'setError',
    'toggleSpinner',
], namespace);

function showSpinner() {
    return dispatch => {
        dispatch({
            type: teacherListActions.toggleSpinner,
            payload: true,
        });
    }
}

function hideSpinner() {
    return dispatch => {
        dispatch({
            type: teacherListActions.toggleSpinner,
            payload: false,
        });
    }
}

function setTeacherList(listOfIds) {
    return dispatch => {
        dispatch({
            type: teacherListActions.setTeacherList,
            payload: listOfIds,
        });
    }
}

function getTeachersApiSuccess(res) {
    console.log(res)
    return dispatch => {
        const ids = [];
        res.data.forEach(teacher => {
            const teacherObj = map2TeacherObj(teacher);
            ids.push(teacherObj.id);
            dispatch(teacherActionCreators.save(teacherObj));
        });
        dispatch(setTeacherList(ids));
        dispatch(hideSpinner());
    }
}

function getTeachersApiFailed(err) {
    return dispatch => {
        dispatch({
            type: teacherListActions.setError,
            payload: err,
        })
        dispatch(hideSpinner('teacher-list'));
    }
}

function getTeachersFromApi() {
    return dispatch => {
        dispatch(showSpinner('teacher-list'));
        ajaxJson.get('/lecturers').then(
            res => dispatch(getTeachersApiSuccess(res)),
            err => dispatch(getTeachersApiFailed(err)),
        );
    }
}

export const teacherListActionsCreators = {
    getTeachersFromApi
}